import { useCallback, useState } from 'react';
import { ZoomRecordingPickerModal, useZoomRecordingsPickerModal } from 'components/WorkspaceFiles/ZoomRecordingPickerModal';

export const useZoomRecordingUpload = () => {
  const [openModal, Modal] = useZoomRecordingsPickerModal();

  return [openModal, Modal] as const;
};